import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { editOrganisationProfile } from '@api/organisations';

import { IOrganisationFormDTO } from '@interfaces/organisation/dto/organisationsDTO';

import { ESnackbarTypes } from '@enums/common';

import { ORGANISATION_PROFILE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateEditOrganisationProfile = (id: string) => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: handleUpdateOrganisation,
		isLoading: isLoadingUpdateOrganisation,
	} = useMutation({
		mutationKey: [ORGANISATION_PROFILE, id],
		mutationFn: async ({ id, values, closeModals }: {
			id?: string;
			values?: IOrganisationFormDTO;
			closeModals?: () => void;
		}) => {
			return editOrganisationProfile({ id, values })
				.then(() => {
					if (closeModals) closeModals();

					dispatch(setSnackbar({
						message: responseMessages.updatedOrganisation,
						type: ESnackbarTypes.success,
					}));

					return queryClient.invalidateQueries([ORGANISATION_PROFILE]);
				});
		},
	});

	return {
		handleUpdateOrganisation,
		isLoadingUpdateOrganisation,
	};
};
